import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { OpenSearchField } from './CreateOpensearchExtension';

export const CreateOpensearchExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'OpenSearchField',
    component: OpenSearchField,
  }),
);
